import { render, staticRenderFns } from "./SideDialogWelcome.vue?vue&type=template&id=6af9b18a&"
import script from "./SideDialogWelcome.vue?vue&type=script&lang=js&"
export * from "./SideDialogWelcome.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideDialogWelcome.vue"
export default component.exports